export enum ValidationErrorType {
  Empty = 'EMPTY',
  TooShort = 'TOO_SHORT',
  TooLong = 'TOO_LONG',
  IncorrectSymbols = 'INCORRECT_SYMBOLS',
  IncorrectExtremeSymbols = 'INCORRECT_EXTREME_SYMBOLS',
  AlreadyExists = 'ALREADY_EXISTS',
  Invalid = 'INVALID',
  PhoneInvalid = 'PHONE_INVALID',
  InvalidVerificationCode = 'E_INVALID_VERIFICATION_CODE',
  AttemptsExceeded = 'E_ATTEMPTS_EXCEEDED',
  VerificationCodeExpired = 'E_VERIFICATION_CODE_EXPIRED',
  BirthdayInvalid = 'BIRTHDAY_INVALID',
  BirthdayUnderAge = 'BIRTHDAY_UNDER_AGE',
}

export interface IFieldValidationParams {
  value: string;
  errorToText: Partial<Record<ValidationErrorType, string>>;
}
